import { AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

export const FOCUSABLE_ELEMENTS_QUERY = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

@Directive({
  selector: '[appAutoFocus]',
})
export class AutoFocusDirective implements AfterViewInit, OnChanges {
  @Input() public appAutoFocus: boolean = false;

  constructor(public elementRef: ElementRef) {}

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.appAutoFocus) this.focus();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['appAutoFocus']) {
      setTimeout(() => {
        if (this.appAutoFocus) this.focus();
      });
    }
  }

  private focus() {
    let elementToFocus: HTMLElement | null = null;
    const nativeElement: HTMLElement = this.elementRef.nativeElement as HTMLElement;

    if (!nativeElement) return;

    if (this.isFocusable(nativeElement)) {
      elementToFocus = this.elementRef.nativeElement;
    } else {
      const focusableElements = nativeElement.querySelectorAll(FOCUSABLE_ELEMENTS_QUERY);

      if (focusableElements && focusableElements.length > 0) {
        elementToFocus = focusableElements[0] as HTMLElement;
      }
    }

    if (elementToFocus) {
      elementToFocus.focus();
    }
  }

  private isFocusable(element: HTMLElement): boolean {
    const tagName = element.tagName.toLowerCase();

    return (
      tagName === 'input' ||
      tagName === 'button' ||
      tagName === 'select' ||
      tagName === 'textarea' ||
      element.hasAttribute('href') ||
      (element.hasAttribute('tabindex') && element.tabIndex !== null && element.tabIndex !== -1)
    );
  }
}
